/**
 * Everything here is a jeugdbrandweerkorps, so the word crowds out the half of the naam that tells
 * two rows apart. Display only; the voorvoegsels are `tools/wedstrijdboekjes/kalender.py`'s.
 */
const voorvoegsels = [
  "jeugdbrandweerkorps ",
  "jeugdbrandweer ",
  "jeugd brandweer ",
  "brandweer ",
  "jbrw ",
  "jbw ",
];

export function zonderVoorvoegsel(naam: string): string {
  const gevouwen = naam.toLowerCase();
  const voorvoegsel = voorvoegsels.find((v) => gevouwen.startsWith(v));
  if (voorvoegsel === undefined) return naam;

  const rest = naam.slice(voorvoegsel.length).trim();
  return rest.length > 0 ? rest : naam;
}
